import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-individual-entity-divider',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="individual-entity-divider">{{ dividerText() }}</div>
  `,
  styles: `
    .individual-entity-divider {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 12px;
      color: var(--gray-700);
      background-color: var(--gray-100);
    }
  `
})
export class IndividualEntityDividerComponent implements ICellRendererAngularComp {
  dividerText = signal<string>('');

  agInit(params: ICellRendererParams<string>): void {
    this.updateCell(params);
  }

  refresh(params: ICellRendererParams<string>): boolean {
    return this.updateCell(params);
  }

  private updateCell(params: ICellRendererParams<string>): boolean {
    this.dividerText.set(params.data ?? '');
    return true;
  }
}
